import type Store from "@ember-data/store";
import Route from "@ember/routing/route";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import type NetworkDetectorService from "parog-web/services/network-detector";
import type SemeiaSessionService from "parog-web/services/session";

export default class IndexRoute extends Route {
  @service declare networkDetector: NetworkDetectorService;
  @service declare router: RouterService;
  @service declare session: SemeiaSessionService;
  @service declare store: Store;

  afterConnectionSaved = () => {
    return;
  };

  override beforeModel() {
    const authenticatedAs = this.session.data.authenticated.as;
    if (authenticatedAs === "medic") {
      this.router.transitionTo("medics-web.protected.index");

      const connectionInfo = this.networkDetector.detectConnection();
      this.saveConnectionInfo(
        connectionInfo,
        "Medic",
        this.session.medic?.id,
        "MedicsWeb"
      ).then(
        this.afterConnectionSaved, // onFulfilled callback
        this.afterConnectionSaved // onRejected callback
      );
    } else if (authenticatedAs === "patient") {
      this.router.transitionTo("patient-web.protected");

      const connectionInfo = this.networkDetector.detectConnection();
      this.saveConnectionInfo(
        connectionInfo,
        "Patient",
        this.session.medic?.id,
        "PatientsWeb"
      ).then(
        this.afterConnectionSaved, // onFulfilled callback
        this.afterConnectionSaved // onRejected callback
      );
    } else {
      this.router.transitionTo("login");
      return;
    }
  }

  async saveConnectionInfo(connectionInfo, creatorType, creatorId, appType) {
    if (!connectionInfo) return;

    await this.store
      .createRecord("user-connection-journal-event", {
        occurredAt: new Date(),
        networkInformation: connectionInfo.effectiveType,
        creatorType: creatorType,
        creatorId: creatorId,
        appType: appType
      })
      .save();
  }
}
